import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import * as prismicH from '@prismicio/helpers'
import { Link } from 'gatsby'
import {
  Container,
  Box,
  Flex,
  Tabs,
  Tab,
  TabList,
  TabPanels,
  TabPanel,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon
} from "@chakra-ui/react";
import { PrismicRichText } from "@prismicio/react";

import DonateModal from "../DonateForm/DonateModal";
import ContactModal from "../VolunteerForm/VolunteerModal";
import { BsFileEarmarkPdf } from 'react-icons/bs'
import { ExternalLinkIcon } from '@chakra-ui/icons';

const RichTextImage = () => {
  return (
    <div className="an-image">
      <img />
    </div>
  )
}

export default function TabSection({ slice }) {
  console.log(slice)
  return (
    <Container my="12" maxW="container.xl">

      <Box display={{base: 'block', md: 'none'}}>
        <Accordion allowMultiple>
        {slice.items.map((item, index) => (
          <AccordionItem key={index}>
            <h2>
              <AccordionButton fontSize="1.375rem" color="sage.700">
                <Box flex='1' textAlign='left'>
                {item.tab_title}
                </Box>
                <AccordionIcon />
              </AccordionButton>
            </h2>
            <AccordionPanel pb={4}>
            {prismicH.isFilled.richText(item.tab_content.richText) && ( 
            <PrismicRichText
              field={item.tab_content.richText}
            />)}
              {/* <PrismicRichText field={item.tab_content.richText} /> */}
              {item.chamber_member_logos?.document && (
                    <Flex w="100%" h="100%" flexWrap="wrap" justifyContent="center">
                      {item.chamber_member_logos.document.data.logo_group.map(
                        (member, index1) => {
                          return (
                          <Flex key={index1} w='50%' p="4" alignItems="center">
                              <a href={member.link.url} target="_blank" rel="noopener noreferrer"><GatsbyImage image={getImage(member.logo.localFile)} alt={member.logo.alt} style={{height: 'unset', width: '100%'}} /></a>
                          </Flex>
                        )}
                      )}
                    </Flex>
                  )}
            </AccordionPanel>
          </AccordionItem>
        ))}
        </Accordion>
      </Box>

      <Box display={{base: 'none', md: 'block'}}>
        <Tabs isFitted variant='unstyled'>
          <TabList>
            {slice.items.map((item, index) => (
              <Tab
                bg="sage.200"
                key={index}
                fontWeight="900"
                fontFamily="heading"
                fontSize="1.25rem"
                textTransform="uppercase"
                color="sage.700"
                borderColor="sage.500"
                border="1px solid #70A37F"
                borderTopRadius="xl"
                _selected={{ color: 'white', bg: 'sage.500', borderColor: 'sage.600' }}
              >
                {item.tab_title}
              </Tab>
            ))}
          </TabList>
          <TabPanels border="1px solid #D3E3D8" boxShadow="lg">
            {slice.items.map((tabContent, idx) => {
              return (
                <TabPanel key={idx}>
                  <Box p="16" className="rich-text">
                  {prismicH.isFilled.richText(tabContent.tab_content.richText) && ( 
                    <PrismicRichText
                      field={tabContent.tab_content.richText}
                      // components={components}
                    />)}
                  </Box>
                  
                  {/* Conditionally render the donate and contact modals */}
                  {tabContent.tab_title === 'Support The GEO' && 
                  (
                    <Flex px="16" w="100%" justifyContent="center">
                      <Box px="4">
                        <DonateModal />
                      </Box>
                      <Box px="4">
                        <ContactModal />
                      </Box>
                    </Flex>
                  )
                  }
                  {tabContent.chamber_member_logos?.document && (
                    <Flex w="100%" h="100%" flexWrap="wrap" justifyContent="center">
                      {tabContent.chamber_member_logos.document.data.logo_group.map(
                        (member, index1) => {
                          return (
                          <Flex key={index1} w={{base: '25%', md: '20%'}} p="4" alignItems="center">
                              <a href={member.link.url} target="_blank" rel="noopener noreferrer"><GatsbyImage image={getImage(member.logo.localFile)} alt={member.logo.alt} style={{height: 'unset', width: '100%'}} /></a>
                          </Flex>
                        )}
                      )}
                    </Flex>
                  )}
                </TabPanel>
              );
            })}
          </TabPanels>
        </Tabs>
      </Box>
    </Container>
  );
}
